import { useState } from 'react';
import type { PublicStoreConfig } from '../types';

interface Props {
  config: PublicStoreConfig | null;
  storeName: string;
  onClose?: () => void;
  /** Centering wrapper class so header content aligns with the chat column. */
  contentClass?: string;
}

export function StoreHeader({ config, storeName, onClose, contentClass = 'w-full' }: Props) {
  const initial = (storeName || 'S').trim().charAt(0).toUpperCase();
  const [logoFailed, setLogoFailed] = useState(false);

  return (
    <header className="shrink-0 border-b border-border bg-white">
      <div className={`flex h-14 items-center gap-3 px-4 ${contentClass}`}>
      {config?.logoUrl && !logoFailed ? (
        <img
          src={config.logoUrl}
          alt={storeName}
          onError={() => setLogoFailed(true)}
          className="h-9 w-9 rounded-full object-cover ring-1 ring-border"
        />
      ) : (
        <div
          className="flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-white"
          style={{ backgroundColor: 'var(--brand-accent)' }}
        >
          {initial}
        </div>
      )}

      <div className="min-w-0 flex-1">
        <h1 className="truncate text-sm font-semibold leading-tight text-primary">{storeName}</h1>
        <div className="flex items-center gap-1.5">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-success opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-success" />
          </span>
          <span className="text-[11px] font-medium text-mid">Online</span>
        </div>
      </div>

      {onClose && (
        <button
          onClick={onClose}
          aria-label="Close chat"
          className="flex h-8 w-8 items-center justify-center rounded-full text-mid transition-colors hover:bg-surface"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
      )}
      </div>
    </header>
  );
}

export default StoreHeader;
